import { LanguageSwitcher } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { type SupportedLanguage, supportedLanguages } from '@/locales';

const LANGUAGE_LABELS: Record<
  SupportedLanguage,
  { label: string; shortLabel: string; flag: string }
> = {
  'pt-BR': { label: 'Português (BR)', shortLabel: 'PT', flag: '🇧🇷' },
  'en-US': { label: 'English (US)', shortLabel: 'EN', flag: '🇺🇸' },
};

const LANGUAGES = supportedLanguages.map((code) => ({
  code,
  label: LANGUAGE_LABELS[code].label,
  shortLabel: LANGUAGE_LABELS[code].shortLabel,
  flag: <span aria-hidden>{LANGUAGE_LABELS[code].flag}</span>,
}));

export function LanguageMenu() {
  const { i18n, t } = useTranslation('common');
  return (
    <LanguageSwitcher
      languages={LANGUAGES}
      value={i18n.resolvedLanguage ?? i18n.language}
      onValueChange={(code) => {
        void i18n.changeLanguage(code);
      }}
      triggerLabel={t('nav.language')}
      triggerVariant="ghost"
    />
  );
}
